export const salesChannels = ['B2C-EU', 'B2C-CH', 'B2B-EU', 'B2B-CH'] as const
